enum RailyOfficerListingFilterType {
  FIRST_NAME = "FIRST_NAME",
  LAST_NAME = "LAST_NAME",
  USERNAME = "USERNAME",
  EMAIL = "EMAIL",
  ACTIVITY_STATUS = "STATUS",
}

export default RailyOfficerListingFilterType;
